import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, projectUrl }) => {
  const heading = <h4>{title}</h4>;

  return (
    <Col xs={12} sm={6} md={4}>
      <div className="proj-imgbx">
        {imgUrl
          ? <img src={imgUrl} alt={title} loading="lazy" />
          : <div className="proj-placeholder">{title}</div>}
        <div className="proj-txtx">
          {projectUrl
            ? <a target="_blank" rel="noopener noreferrer" href={projectUrl}>{heading}</a>
            : heading}
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}
